<app-header></app-header>
<app-menu></app-menu>

<div nxLayout="grid">
  <div nxRow class="ptop2percent">
    <div nxCol="12,12,12,4">
      <nx-card>
        <nx-card-header>
          <h2 nxHeadline="subsection-small">TOTAl REVENUE (BTD)</h2>
        </nx-card-header>
        <canvas id="canvas" width="350" height="300"></canvas>
        <div class="txtalign_center colorRed">
          <h5>POLICIES SOLD ON THIS WEEK: {{ ChartCal?.btdPolicies }}</h5>
          <h5>TOTAL : {{ ChartCal?.btdAmount }}</h5>
        </div>
        <nx-radio-toggle [variant]="'small'" name="btdChartType" [(ngModel)]="btdChartType"
          (click)="changeChartType('BTD')">
          <nx-radio-toggle-button value="1" [selected]="true">
            <nx-icon name="product-stock-data-graph"></nx-icon>
          </nx-radio-toggle-button>
          <nx-radio-toggle-button value="2">
            <nx-icon name="product-share-graph-arrow-up"></nx-icon>
          </nx-radio-toggle-button>
          <nx-radio-toggle-button value="3">
            <nx-icon name="in-progress"></nx-icon>
          </nx-radio-toggle-button>
        </nx-radio-toggle>
      </nx-card>
    </div>

    <div nxCol="12,12,12,4">
      <nx-card>
        <nx-card-header>
          <h2 nxHeadline="subsection-small">TOTAl REVENUE (MTD)</h2>
        </nx-card-header>
        <canvas id="canvas1" width="350" height="300"></canvas>
        <div class="txtalign_center colorBlue">
          <h5>POLICIES SOLD ON CURRENT MONTH : {{ ChartCal?.mtdPolicies }}</h5>
          <h5>TOTAL : {{ ChartCal?.mtdAmount }}</h5>
        </div>
        <nx-radio-toggle [variant]="'small'" name="mtdChartType" [(ngModel)]="mtdChartType"
          (click)="changeChartType('MTD')">
          <nx-radio-toggle-button value="1" [selected]="true">
            <nx-icon name="product-stock-data-graph"></nx-icon>
          </nx-radio-toggle-button>
          <nx-radio-toggle-button value="2">
            <nx-icon name="product-share-graph-arrow-up"></nx-icon>
          </nx-radio-toggle-button>
          <nx-radio-toggle-button value="3">
            <nx-icon name="in-progress"></nx-icon>
          </nx-radio-toggle-button>
        </nx-radio-toggle>
      </nx-card>
    </div>

    <div nxCol="12,12,12,4">
      <nx-card>
        <nx-card-header>
          <h2 nxHeadline="subsection-small">TOTAl REVENUE (YTD)</h2>
        </nx-card-header>
        <canvas id="canvas2" width="350" height="300"></canvas>
        <div class="txtalign_center colorLaven">
          <h5>POLICIES SOLD ON CURRENT YEAR : {{ ChartCal?.ytdPolicies }}</h5>
          <h5>TOTAL : {{ ChartCal?.ytdAmount }}</h5>
        </div>
        <nx-radio-toggle [variant]="'small'" name="ytdChartType" [(ngModel)]="ytdChartType"
          (click)="changeChartType('YTD')">
          <nx-radio-toggle-button value="1" [selected]="true">
            <nx-icon name="product-stock-data-graph"></nx-icon>
          </nx-radio-toggle-button>
          <nx-radio-toggle-button value="2">
            <nx-icon name="product-share-graph-arrow-up"></nx-icon>
          </nx-radio-toggle-button>
          <nx-radio-toggle-button value="3">
            <nx-icon name="in-progress"></nx-icon>
          </nx-radio-toggle-button>
        </nx-radio-toggle>
      </nx-card>
    </div>
  </div>
</div>
<app-footer></app-footer>

<!-- Update Mandarory details of workshop/Dealer if its missing -->
<ng-template *ngIf="isShowWorkshopEdit">
  <app-workshop-edit (closeModal)="onCloseModal($event)"></app-workshop-edit>
</ng-template>